<template>
  <el-select
    v-model="currentValue"
    placeholder="请选择"
    :loading="loading"
    @change="handleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.dictValue"
      :label="item.dictLabel"
      :value="item.dictValue"
    />
  </el-select>
</template>

<script>

export default {
  name: "DictSelect",
  props: {
    dictType: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      options: [],
      currentValue: this.value,
      loading: false
    }
  },
  watch: {
    dictType: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal){
          this.loadDictData();
        }
      }
    },
    value(newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      this.currentValue = newVal;
    }
  },
  methods: {
    async loadDictData() {
      const dictData = this.$store.getters["dict/getDict"](this.dictType);
      if (dictData && Object.keys(dictData).length !== 0) {
        this.options = dictData
        return
      }
      try {
        await this.$store.dispatch("dict/fetchDictData", { dictType: this.dictType }).then(() => {
          this.options = this.$store.getters['dict/getDict'](this.dictType)
        })
      } finally {
        this.loading = false;
      }
    },
    handleChange(value) {
      this.$emit('input', value);
      const selectedItem = this.options.find(item => item.value === value);
      this.$emit('change', value, selectedItem);
    }
  }
}
</script>
